import _regeneratorRuntime from "/opt/build/repo/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/opt/build/repo/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/opt/build/repo/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/build/repo/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { LargeFileUploadTask } from "./LargeFileUploadTask";
import { getValidRangeSize } from "./OneDriveLargeFileUploadTaskUtil";
/**
 * @class
 * Class representing OneDriveLargeFileUploadTask
 */

export var OneDriveLargeFileUploadTask =
/*#__PURE__*/
function (_LargeFileUploadTask) {
  _inherits(OneDriveLargeFileUploadTask, _LargeFileUploadTask);

  /**
   * @public
   * @constructor
   * Constructs a OneDriveLargeFileUploadTask
   * @param {Client} client - The GraphClient instance
   * @param {FileObject} file - The FileObject holding details of a file that needs to be uploaded
   * @param {LargeFileUploadSession} uploadSession - The upload session to which the upload has to be done
   * @param {LargeFileUploadTaskOptions} options - The upload task options
   * @returns An instance of OneDriveLargeFileUploadTask
   */
  function OneDriveLargeFileUploadTask(client, file, uploadSession, options) {
    _classCallCheck(this, OneDriveLargeFileUploadTask);

    return _possibleConstructorReturn(this, _getPrototypeOf(OneDriveLargeFileUploadTask).call(this, client, file, uploadSession, options));
  }
  /**
   * @private
   * @static
   * Constructs the create session url for Onedrive
   * @param {string} fileName - The name of the file
   * @param {path} [path = OneDriveLargeFileUploadTask.DEFAULT_UPLOAD_PATH] - The path for the upload
   * @returns The constructed create session url
   */


  _createClass(OneDriveLargeFileUploadTask, [{
    key: "commit",

    /**
     * @public
     * Commits upload session to end uploading
     * @param {string} requestUrl - The URL to commit the upload session
     * @returns The promise resolves to committed response
     */
    value: function commit(requestUrl) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var payload;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                payload = {
                  name: this.file.name,
                  "@microsoft.graph.conflictBehavior": "rename",
                  "@microsoft.graph.sourceUrl": this.uploadSession.url
                };
                _context.next = 4;
                return this.client.api(requestUrl).put(payload);

              case 4:
                return _context.abrupt("return", _context.sent);

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                throw _context.t0;

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));
    }
  }], [{
    key: "constructCreateSessionUrl",
    value: function constructCreateSessionUrl(fileName) {
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : OneDriveLargeFileUploadTask.DEFAULT_UPLOAD_PATH;
      fileName = fileName.trim();
      path = path.trim();

      if (path === "") {
        path = "/";
      }

      if (path[0] !== "/") {
        path = "/".concat(path);
      }

      if (path[path.length - 1] !== "/") {
        path = "".concat(path, "/");
      }

      return encodeURI("/me/drive/root:".concat(path).concat(fileName, ":/createUploadSession"));
    }
    /**
     * @public
     * @static
     * @async
     * Creates a OneDriveLargeFileUploadTask
     * @param {Client} client - The GraphClient instance
     * @param {Blob | Buffer | File} file - File represented as Blob, Buffer or File
     * @param {OneDriveLargeFileUploadOptions} options - The options for upload task
     * @returns The promise that will be resolves to OneDriveLargeFileUploadTask instance
     */

  }, {
    key: "create",
    value: function create(client, file, options) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var name, content, size, b, requestUrl, session, rangeSize, fileObj;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                name = options.fileName;
                _context2.t0 = file.constructor.name;
                _context2.next = _context2.t0 === "Blob" ? 4 : _context2.t0 === "File" ? 7 : _context2.t0 === "Buffer" ? 10 : 14;
                break;

              case 4:
                content = new File([file], name);
                size = content.size;
                return _context2.abrupt("break", 14);

              case 7:
                content = file;
                size = content.size;
                return _context2.abrupt("break", 14);

              case 10:
                b = file;
                size = b.byteLength - b.byteOffset;
                content = b.buffer.slice(b.byteOffset, b.byteOffset + b.byteLength);
                return _context2.abrupt("break", 14);

              case 14:
                _context2.prev = 14;
                requestUrl = OneDriveLargeFileUploadTask.constructCreateSessionUrl(options.fileName, options.path);
                _context2.next = 18;
                return OneDriveLargeFileUploadTask.createUploadSession(client, requestUrl, options.fileName);

              case 18:
                session = _context2.sent;
                rangeSize = getValidRangeSize(options.rangeSize);
                fileObj = {
                  name: name,
                  content: content,
                  size: size
                };
                return _context2.abrupt("return", new OneDriveLargeFileUploadTask(client, fileObj, session, {
                  rangeSize: rangeSize
                }));

              case 24:
                _context2.prev = 24;
                _context2.t1 = _context2["catch"](14);
                throw _context2.t1;

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[14, 24]]);
      }));
    }
    /**
     * @public
     * @static
     * @async
     * Makes request to the server to create an upload session
     * @param {Client} client - The GraphClient instance
     * @param {string} requestUrl - The URL to create the upload session
     * @param {string} fileName - The name of a file to upload, (with extension)
     * @returns The promise that resolves to LargeFileUploadSession
     */

  }, {
    key: "createUploadSession",
    value: function createUploadSession(client, requestUrl, fileName) {
      var _this = this;

      var _super = Object.create(null, {
        createUploadSession: {
          get: function get() {
            return _get(_getPrototypeOf(OneDriveLargeFileUploadTask), "createUploadSession", _this);
          }
        }
      });

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var payload;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                payload = {
                  item: {
                    "@microsoft.graph.conflictBehavior": "rename",
                    name: fileName
                  }
                };
                _context3.prev = 1;
                return _context3.abrupt("return", _super.createUploadSession.call(this, client, requestUrl, payload));

              case 5:
                _context3.prev = 5;
                _context3.t0 = _context3["catch"](1);
                throw _context3.t0;

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 5]]);
      }));
    }
  }]);

  return OneDriveLargeFileUploadTask;
}(LargeFileUploadTask);
/**
 * @private
 * @static
 * Default path for the file being uploaded
 */

OneDriveLargeFileUploadTask.DEFAULT_UPLOAD_PATH = "/";